export const APPLICATION_STAGE = {
  APPLICATION: 'APPLICATION',
  PRE_SUBMISSION: 'PRE_SUBMISSION',
};
